'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFoundPage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFoundPage() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactHelmet2.default, { title: '404' }),
    _react2.default.createElement(
      'h1',
      null,
      '404'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Not Found'
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/NotFoundPage/index.js
// module id = 2330
// module chunks = 0